import { LinearProgress } from "@mui/material";
import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import { FormikAutocomplete } from "@poseidon/ui/components/form/FormikAutocomplete";
import { Field } from "formik";
import { useEffect } from "react";
import { useCountries } from "../../hooks/useCountries";

export const CountriesField = ({
  label,
  name,
  withCode,
  disabled,
  ...props
}) => {
  const { countries, loading, error } = useCountries(withCode);
  const { setError } = useErrorMessage();
  useEffect(() => {
    if (error) {
      setError(error);
    }
  }, [setError, error]);

  if (loading || !countries) {
    return <LinearProgress />;
  }

  const withCodeProps = withCode
    ? {
        isOptionEqualToValue: (option, value) => option.id === value.id,
      }
    : {};

  return (
    <Field
      component={FormikAutocomplete}
      fullWidth={true}
      label={label}
      name={name}
      options={
        withCode
          ? countries.map((c) => ({ label: c.country, id: c.code }))
          : countries.map((c) => c.country)
      }
      margin="none"
      disabled={disabled}
      {...withCodeProps}
      {...props}
    />
  );
};
